/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

/** Ce que la situation antérieure d'un conjoint autorise comme champs. */
export interface RegleEtatAnterieurConjoint {
  /** Libellé du champ de date ; absent ⇒ cette situation n'a pas de date. */
  libelleDate?: string;
  /** Mot désignant l'ancien conjoint ; absent ⇒ pas de bloc ex-conjoint. */
  roleExConjoint?: 'conjoint' | 'partenaire';
}

/**
 * Champs autorisés par situation antérieure du conjoint, indexés par le code du
 * référentiel (`ec_etamat.em_codj`, contexte `M_EPX/EPSE`).
 *
 * Quatre situations seulement, et pas de « marié(e) » : le référentiel n'en
 * propose pas pour un conjoint, ce qui se comprend avant un mariage.
 *
 * Chaque situation porte sa date dans SA colonne (`am_ex_div_date`,
 * `am_ex_vve_date`, `am_ex_pacs_date`) — c'est ce partage qui permet de nommer
 * la date à l'écran plutôt que d'afficher un « Date » muet.
 *
 * ⚠️ Pas de sexe pour l'ex-conjoint, contrairement au décès : `ec_actm` n'en a
 * pas de colonne. Nom et prénom, rien de plus.
 *
 * Source unique : l'assistant, la modale et le descripteur de la fiche lisent
 * cette table, et l'API en applique l'équivalent à l'écriture
 * (`ActeMariageRepository::CHAMPS_PAR_ETAT_ANTERIEUR`).
 */
export const REGLES_ETAT_ANTERIEUR_CONJOINT: Record<
  string,
  RegleEtatAnterieurConjoint
> = {
  C: {},
  D: { libelleDate: 'Divorcé(e) le', roleExConjoint: 'conjoint' },
  P: { libelleDate: 'Pacsé(e) le', roleExConjoint: 'partenaire' },
  V: { libelleDate: 'Veuf(ve) le', roleExConjoint: 'conjoint' },
};

/** Règle d'une situation, ou une règle vide si le code est inconnu ou absent. */
export const regleEtatAnterieurConjoint = (
  code?: string | null,
): RegleEtatAnterieurConjoint =>
  REGLES_ETAT_ANTERIEUR_CONJOINT[(code ?? '').trim().toUpperCase()] ?? {};

export default REGLES_ETAT_ANTERIEUR_CONJOINT;
